import styled from 'styled-components';

import { useTranslation } from '@ciam/i18n';
import { Button } from '@ciam/ui';
import { GigyaAPI } from '@ciam/gigya-api';

export const AdUserLoginButton = () => {
  const { t } = useTranslation('login');

  const handleClick = async () => {
    await GigyaAPI.accounts.socialLogin({ provider: 'saml-samsung-ad' });
  };

  return (
    <AdUserButton size="m" buttonTheme="lined-blue" onClick={handleClick}>
      {t('form.fields.button.samsung-employee-sign-in')}
    </AdUserButton>
  );
};

const AdUserButton = styled(Button)`
  ${({ theme }) => theme.getFontStyle('samsung-400-14')};
  margin-top: 2rem;
`;
